import React from 'react'
import {Input} from 'forms'
import {AddressEncoder} from 'ui'

// expected to be include inside a <Form /> tag

const Info = ({network}) => (
   <dl className="dl-horizontal dl-form">
      <dt>Key</dt>
      <dd>{network.key}</dd>

      <dt>Address</dt>
      <dd><AddressEncoder value={network.address} /></dd>

      <dt>Name</dt>
      <dd>
         <Input.Toggleable param="name" value={network.name}>
            Unnamed Network
         </Input.Toggleable>
      </dd>
   </dl>
)

Info.propTypes = {
   network: React.PropTypes.object.isRequired
}

export default Info



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/overview/Info.jsx